"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _hyperLink = _interopRequireDefault(require("promo-js/lib/hyper-link"));

var _directionTypes = _interopRequireDefault(require("../../../consts/direction-types"));

var _direction = _interopRequireDefault(require("../../../shapes/direction.shape"));

class NavButton extends _react.Component {
  renderContent() {
    const {
      children,
      direction
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, direction === _directionTypes.default.LEFT && /*#__PURE__*/_react.default.createElement("span", {
      className: "nav-button__arrow nav-button__left"
    }), children, (direction === _directionTypes.default.RIGHT || direction === _directionTypes.default.BOTTOM || direction === _directionTypes.default.TOP) && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)('nav-button__arrow', "nav-button__".concat(direction))
    }));
  }

  render() {
    const _this$props = this.props,
          {
      onClick,
      href,
      className,
      disabled
    } = _this$props,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["onClick", "href", "className", "disabled"]);
    const classes = (0, _classnames.default)(className, {
      'nav-button--disabled': disabled
    });

    if (href) {
      return /*#__PURE__*/_react.default.createElement(_hyperLink.default, (0, _extends2.default)({
        href: href,
        className: (0, _classnames.default)('nav-button', classes)
      }, otherProps), this.renderContent());
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      onClick: onClick,
      className: (0, _classnames.default)('nav-button', classes)
    }, this.renderContent());
  }

}

(0, _defineProperty2.default)(NavButton, "propTypes", {
  children: _propTypes.default.node.isRequired,
  direction: _direction.default,
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  as: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool
});
(0, _defineProperty2.default)(NavButton, "defaultProps", {
  direction: null,
  onClick: null,
  href: null,
  as: null,
  className: '',
  disabled: false
});
var _default = NavButton;
exports.default = _default;